import { render, staticRenderFns } from "./TablePitchesHead.vue?vue&type=template&id=4dc5802b"
import script from "./TablePitchesHead.vue?vue&type=script&lang=js"
export * from "./TablePitchesHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports